export default "__VITE_ASSET__Djy94zWD__"